import { faMapMarkerAlt } from '@fortawesome/pro-regular-svg-icons/faMapMarkerAlt';
import Font from '@maxpreps/shared/styles/font';
import { ReactNode } from 'react';
import { useIsScreenSize } from '../../hooks/useIsScreenSize';
import { COLOR } from '../../styles/colors';
import Icon from '../../ui/Icon/Icon';
import StyledText from '../../ui/Text/StyledText';
import Anchor from '../Anchor/Anchor';
import Mascot from '../Image/Mascot';
import { SITE_NAV_BREAK_POINT } from '../SiteNav/SiteNavUtils';
import {
  StyledLocation,
  StyledSchoolTeamHeader,
  StyledTextContainer
} from './StyledSchoolTeamHeader';

interface ISchoolTeamHeaderProps {
  title: string;
  subTitle: string;
  schoolMascotUrl: string;
  schoolCanonicalUrl: string;
  schoolName: string;
  schoolCity: string;
  schoolStateCode: string;
  rightAction?: ReactNode;
}

const SchoolTeamHeader: React.FC<ISchoolTeamHeaderProps> = ({
  title,
  subTitle,
  schoolMascotUrl,
  schoolCanonicalUrl,
  schoolName,
  schoolCity,
  schoolStateCode,
  rightAction
}) => {
  const isDesktop = useIsScreenSize(SITE_NAV_BREAK_POINT);

  const imageSize = isDesktop ? 90 : 46;

  // Technically the a.href == 'schoolCanonicalUrl' could be client side routed when this lives in the school project.
  // Not implementing for now because it will require a bit more logic. We need to find a better way to toggle between
  // anchors and Link when the logic is in a shared component.
  return (
    <>
      <StyledSchoolTeamHeader $hasRightAction={!!rightAction}>
        <Anchor $color={COLOR.white} $display="flex" href={schoolCanonicalUrl}>
          <Mascot
            src={schoolMascotUrl}
            size={imageSize}
            isLazyLoaded={false}
            name={schoolName}
          />
          <StyledTextContainer>
            <StyledText
              className={isDesktop ? Font.f18_bold : Font.f16_bold_tall}
              $color={COLOR.white}
              as="div"
            >
              {title}
            </StyledText>
            <StyledText
              className={isDesktop ? Font.f18_bold : Font.f16_bold_tall}
              $color={COLOR.white}
              as="div"
            >
              {subTitle}
            </StyledText>
            <StyledLocation
              className={Font.f11_bold_tall_upper}
              $color={COLOR.white}
            >
              <Icon icon={faMapMarkerAlt} size={12} color={COLOR.white} />
              {`${schoolCity}, ${schoolStateCode}`}
            </StyledLocation>
          </StyledTextContainer>
        </Anchor>
        {rightAction}
      </StyledSchoolTeamHeader>
    </>
  );
};

export default SchoolTeamHeader;
